export default __webpack_public_path__ + "static/from-abroad-two-295a183be48f8faaa910e6728dd1b287.jpg";